import { createActions , createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions({
  getSuccess: ['data'],
  getRequest: ['data']
}, {
  prefix: "@UserConnector/"
})

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: false,
  data: []
}

const getUserConnectorSuccess = (state = INITIAL_STATE, { data }) => ({
  ...state,
  data,
  loading: false,
  success: true,
})

const getUserConnectorRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
  success: false
})

export default createReducer(INITIAL_STATE, {
  [Types.GET_SUCCESS]: getUserConnectorSuccess,
  [Types.GET_REQUEST]: getUserConnectorRequest,
})